import { ReactNode } from "react"

/** Wraps an inline input so clicking it doesn't trigger the row's navigation. */
export function TableInlineEditCell({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div onClick={(e) => e.stopPropagation()} className={className}>
      {children}
    </div>
  )
}
